import request from '@/utils/request';
import { Alarm808PushConfListDto, Alarm808PushRecordListDto, Alarm808PushRecordUpdateDtoRequest, AlarmListByAlarmTypeRequest, AlarmListByPlateRequest, CreateAlarmPushRequest, RBooleanResponse, RListAlarm808PushRecordResponse, RLongResponse } from './define';

//查询报警推送列表（按照车牌聚合）
export const getAlarmListByPlate = (params: AlarmListByPlateRequest) => {
    return request.post<Alarm808PushConfListDto>('/api/v2/alarm808Push/conf/list/p', params);
};

//查询报警推送列表（按照报警类型集合）
export const getAlarmListByAlarmType = (params: AlarmListByAlarmTypeRequest) => {
    return request.post<Alarm808PushConfListDto>('/api/v2/alarm808Push/conf/list/a', params);
};

//创建报警推送
export const createAlarmPush = (data: CreateAlarmPushRequest) => {
    return request.post<RBooleanResponse>('/api/v2/alarm808Push/conf/insert', data);
}

//删除报警推送
export const deleteAlarmPush = (data: number[]) => {
    return request.delete<RBooleanResponse>('/api/v2/alarm808Push/conf/delete', { data });
}

//查询报警记录
export const getAlarmRecords = (params: Alarm808PushRecordListDto) => {
    return request.post<RListAlarm808PushRecordResponse>('/api/v2/alarm808Push/record/list', params );
}
//修改报警记录
export const updateAlarmRecord = (params: Alarm808PushRecordListDto)=>{
    return request.post<RBooleanResponse>('/api/v2/alarm808Push/record/update', params);   
}
//查询报警数量
export const getAlarmCount = ()=> {
    return request.get<RLongResponse>('/api/v2/alarm808Push/record' );
}
//设备报警批量操作
export const batchAlarmOperation = (data:Alarm808PushRecordUpdateDtoRequest)=>{
    return request.post<RBooleanResponse>('/api/v2/alarm808Push/record/batchUpdate', data);   
}